import { FC, ReactNode } from "react";
import ReactDOMServer from "react-dom/server";
import DOMPurify from "dompurify";
import { InformationBadgeWrapper } from "./InformationBadge.style";
import { MuiTypography } from "../../components";

interface InformationBadgeProps {
  message: string;
  icon?: ReactNode; // Optional icon
  position?: "start" | "end"; // Position of the icon
  className?: string; // Optional className for additional styling
}

export const InformationBadge: FC<InformationBadgeProps> = ({
  message,
  icon,
  position = "start", // Default position is "start"
  className = "", // Default empty className
}) => {
  const labelMessage = DOMPurify.sanitize(message);
  const iconHtml = icon
    ? ReactDOMServer.renderToString(icon as React.ReactElement)
    : "";

  return (
    <InformationBadgeWrapper>
      <MuiTypography
        variant="h3"
        className={`activity-info ${className}`}
        dangerouslySetInnerHTML={{
          __html:
            position === "start"
              ? `${iconHtml} ${labelMessage}`
              : `${labelMessage} ${iconHtml}`,
        }}
      />
    </InformationBadgeWrapper>
  );
};
